import { deriveErrorMessage } from './deriveErrorMessage';

/** Only SETS a banner. Clearing a recovered one is the owning component's useEffect. */
export async function refreshData(refetch, setIsFetching, setErrorMessage, isFetching, component) {
  if (isFetching) {
    return;
  }
  setIsFetching(true);
  try {
    await refetch();
  } catch (e) {
    console.error(`refreshData(${component}) failed`, e);
    setErrorMessage(deriveErrorMessage(e, component));
  } finally {
    setIsFetching(false);
  }
}
